import React, { PureComponent } from 'react';
import {
  ButtonColors,
  LateralMenu,
  Panel,
  SelectorButton,
} from '../../../../components';
import { icons } from '../../../../../assets';
import { linkUserTypes, userRole } from '../../../../../utils';
import './projectUsers.scss';
import { UserItem } from './UserItem';

export class ProjectUsers extends PureComponent {
  state = {
    lateralMenu: false,
    usersSelected: [],
    roleSelected: undefined,
    users: [],
  };

  onUserSelected = role => id => () => {
    const { usersSelected } = this.state;

    this.setState({
      usersSelected:
        usersSelected.findIndex(
          userSelected => userSelected.userId === id && userSelected.role === role
        ) !== -1
          ? usersSelected.filter(
              userSelected => !(userSelected.userId === id && userSelected.role === role)
            )
          : usersSelected.concat({ userId: id, role }),
    });
  };

  getFilterLabel = () => {
    const { strings } = this.props;
    const { roleSelected } = this.state;

    return roleSelected === userRole.FACILITATOR
      ? strings('facilitators')
      : roleSelected === userRole.SUPERVISOR
      ? strings('supervisors')
      : roleSelected === userRole.MENTOR
      ? strings('mentors')
      : '';
  };

  getUsersIdSelected = () => {
    const { usersSelected, roleSelected } = this.state;

    return usersSelected
      .filter(item => item.role === roleSelected)
      .map(item => item.userId);
  };

  onAdd = selectedRole => {
    const { getFacilitators, getMentors, getSupervisors } = this.props;

    switch (selectedRole.key) {
      case userRole.FACILITATOR: {
        getFacilitators();
        break;
      }
      case userRole.MENTOR: {
        getMentors();
        break;
      }
      case userRole.SUPERVISOR: {
        getSupervisors();
        break;
      }
      default: {
        break;
      }
    }

    this.setState({
      lateralMenu: true,
      roleSelected: selectedRole.key,
    });
  };

  addUserSelected = items => {
    const { users } = this.state;
    const { onValueChange } = this.props;
    let tab = [];
    items.map(item => {
      const user = users.filter(usr => usr.id === item.id);

      if (user.length <= 0 && user.length <= 0) {
        tab = tab.concat(item);
        onValueChange && onValueChange({ users: users.concat(...tab) });
      }
    });
    this.setState({
      users: users.concat(...tab),
    });
  };
  getUsersSelected(items) {
    const { usersSelected } = this.state;
    return usersSelected.map(item => {
      const usr = items.filter(user => user.id === item.userId)[0];
      return {
        id: usr.id,
        civility: usr.civility,
        email: usr.details.email,
        firstName: usr.firstName,
        lastName: usr.lastName,
        phone: usr.details.phone,
        role: usr.role,
      };
    });
  }
  validateAdd = () => {
    const { usersData } = this.props;
    const { roleSelected } = this.state;
    const { all } = usersData(0, '', 'all', 'all', 'ALL', roleSelected);
    this.addUserSelected(this.getUsersSelected(all));

    this.setState({ lateralMenu: false, usersSelected: [] });
  };
  unlinkUser = id => {
    const { users } = this.state;
    const { onValueChange } = this.props;
    const usersFiltering = users.filter(usr => usr.id !== id);
    this.setState({ users: usersFiltering });
    onValueChange && onValueChange({ users: usersFiltering });
  };
  render() {
    const {
      strings,
      usersData,
      navigateTo
    } = this.props;
    const { roleSelected, lateralMenu, users } = this.state;

    return (
      <Panel id={'projectUsers'} className={'project-users'}>

        {roleSelected && (
          <LateralMenu
            role={roleSelected}
            filterLabel={this.getFilterLabel()}
            strings={strings}
            visible={lateralMenu}
            label={`${strings(
              'link_one_more'
            )} ${this.getFilterLabel().toLowerCase()}`}
            onClose={() =>
              this.setState({ lateralMenu: false, usersSelected: [] })
            }
            displayAcademiesFilter={roleSelected === userRole.SUPERVISOR}
            data={usersData}
            itemsChecked={this.getUsersIdSelected()}
            onItemSelected={this.onUserSelected(roleSelected)}
            onAdd={this.validateAdd}
            canAdd={this.state.usersSelected.length > 0}
            isProject={false}
          />
        )}
        <div className={'header'}>
          <p className={`medium title`}>{strings('users')}</p>
          <SelectorButton
            color={ButtonColors.orange}
            label={strings('button_text_add')}
            icon={icons.ADD}
            className={`add-button`}
            action={this.onAdd}
            data={Object.entries(linkUserTypes).map(([key, value]) => ({
              key,
              value: strings(value),
            }))}
          />
        </div>
        <div className={'horizontal-dot-separator'} />
        {users && users.length === 0 ? (
          <p className={'no-users'}>{strings('no_users')}</p>
        ) : (
          users.map(user => (
            <UserItem
              user={user}
              key={user.id}
              navigateTo={navigateTo}
              unlinkUser={() => this.unlinkUser(user.id)}
              strings={strings}
            />
          ))
        )}
      </Panel>
    );
  }
}
